import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  CLEAR_VIEWED_STORIES,
  HYDRATE_VIEWED_STORES,
  SET_EMERGENCY_MESSAGE_REQUEST,
  SET_EMERGENCY_MESSAGE_SUCCESS,
  UPDATE_VIEWED_STORIES,
} from "@reducers/actionTypes";
import { actions as miscActions } from "@reducers/miscReducer";
import { getEmergencyMessage } from "@services/api";
import { getData, removeData, setData } from "../lib/storage";

function* getEmerMessage() {
  try {
    const { data } = yield call(getEmergencyMessage);
    if (data) {
      yield put({
        type: SET_EMERGENCY_MESSAGE_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* updateViewedStories(action) {
  const { payload } = action;
  try {
    const viewedStoriesArr = yield call(getData, "cmsViewedStories");
    const stories = Array.isArray(viewedStoriesArr)
      ? [...viewedStoriesArr, ...payload]
      : [...payload];
    yield call(setData, "cmsViewedStories", [...new Set(stories)]);
  } catch (e) {
    console.log(e);
  }
}

function* clearViewedStories() {
  try {
    yield call(removeData, "cmsViewedStories");
  } catch (e) {
    console.log(e);
  }
}

function* hydrateViewedStories() {
  try {
    const stories = yield call(getData, "cmsViewedStories");
    if (stories) {
      yield put(miscActions.updateViewedStories(stories));
    }
  } catch (e) {
    console.log(e);
  }
}

export default function* root() {
  yield all([
    takeLatest(SET_EMERGENCY_MESSAGE_REQUEST, getEmerMessage),
    takeLatest(UPDATE_VIEWED_STORIES, updateViewedStories),
    takeLatest(CLEAR_VIEWED_STORIES, clearViewedStories),
    takeLatest(HYDRATE_VIEWED_STORES, hydrateViewedStories),
  ]);
}
